import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateSelectedFeeSchedule } from '../../../../../services/ContractService/contractSlice';

const CategoryEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const selectedFeeSchedule = useAppSelector((state) => state.contract.currentFeeSchedule);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (selectedFeeSchedule) {
      dispatch(updateSelectedFeeSchedule({
        ...selectedFeeSchedule,
        category: event.target.value
      }));
    }
  };

  return (
    <TextField
      fullWidth
      label="Category"
      value={selectedFeeSchedule?.category || ''}
      onChange={handleChange}
      placeholder="Enter category"
      size="small"
      variant="outlined"
    />
  );
};

export default CategoryEditor;
